import { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';

interface AgentBrandProps {
  label?: string;
  isLive?: boolean;
  /** When provided, the brand renders as a button with a chevron. Used in
   *  compact modes to double as the SessionDropdown trigger. */
  onClick?: () => void;
}

const DotIndicator = () => (
  <div className="relative h-2 w-2 flex-shrink-0" aria-hidden>
    <span className="absolute inset-0 animate-ping rounded-full bg-primary/40" />
    <span className="relative block h-2 w-2 rounded-full bg-primary shadow-[0_0_6px_2px_rgba(98,65,234,0.5)]" />
  </div>
);

// Becomes a button with chevron when onClick is provided; forwardRef lets Radix Popover.Trigger asChild attach its ref.
const AgentBrand = forwardRef<HTMLButtonElement, AgentBrandProps>(
  ({ label = 'OSA Agent', isLive = true, onClick, ...rest }, ref) => {
    if (onClick) {
      return (
        <button
          ref={ref}
          type="button"
          onClick={onClick}
          className="group inline-flex items-center gap-2.5 rounded-md px-1.5 py-1 text-left cursor-pointer focus:outline-none"
          {...rest}>
          {isLive && <DotIndicator />}
          <span className="text-sm font-semibold text-gray-900 transition-colors duration-200 group-hover:text-primary">
            {label}
          </span>
          <ChevronDown
            size={13}
            strokeWidth={1.75}
            className="text-gray-400 transition-colors duration-200 group-hover:text-primary/70"
            aria-hidden
          />
        </button>
      );
    }

    return (
      <div className="inline-flex items-center gap-2.5 px-1.5">
        {isLive && <DotIndicator />}
        <span className="text-sm font-semibold text-gray-900">{label}</span>
      </div>
    );
  },
);

AgentBrand.displayName = 'AgentBrand';

AgentBrand.defaultProps = {
  label: 'OSA Agent',
  isLive: true,
  onClick: undefined,
};

export default AgentBrand;
